export class ProductInfoChatEvent {
  constructor() {
    this.dispatchChatEvent = () => {
      if (document.getElementById('chatHandler')) {
        this.sendProductInfo();
        clearInterval(this.chatInterval);
      }
    };
    this.productCategory = undefined;
    this.productSubCategory = undefined;
    this.productRange = undefined;
    this.productName = undefined;
    this.sendProductInfoUsingInterval = false;
    this.intervalInMs = 500;
  }
  sendProductInfo() {
    document.getElementById('chatHandler').dispatchEvent(new CustomEvent('addProductInfo', {
      detail: {
        productCategory: this.productCategory,
        productSubCategory: this.productSubCategory,
        productRange: this.productRange,
        productName: this.productName,
      },
    }));
  }
  connectedCallback() {
    if (this.sendProductInfoUsingInterval)
      return;
    if (sessionStorage.getItem('embedded_chat_loaded')) {
      this.sendProductInfo();
    }
    else {
      document.addEventListener('chatLoaded', this.sendProductInfo);
    }
  }
  disconnectedCallback() {
    window.removeEventListener('chatLoaded', this.sendProductInfo);
  }
  componentDidLoad() {
    if (this.sendProductInfoUsingInterval) {
      this.chatInterval = setInterval(this.dispatchChatEvent, this.intervalInMs);
    }
  }
  static get is() { return "pes-product-info-chat-event"; }
  static get encapsulation() { return "shadow"; }
  static get properties() {
    return {
      "productCategory": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-category",
        "reflect": false
      },
      "productSubCategory": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-sub-category",
        "reflect": false
      },
      "productRange": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-range",
        "reflect": false
      },
      "productName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-name",
        "reflect": false
      },
      "sendProductInfoUsingInterval": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Use this flag when can't reach chatLoaded event or use better solutions."
        },
        "attribute": "send-product-info-using-interval",
        "reflect": false,
        "defaultValue": "false"
      },
      "intervalInMs": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "interval-in-ms",
        "reflect": false,
        "defaultValue": "500"
      }
    };
  }
}
